export default "__VITE_ASSET__1aafbfc7__"